import { DocumentIsogd } from "isogd-document-rest";

class DocumentRegistrationEditController {
    private document: DocumentIsogd;
}

export const DocumentRegistrationEditComponent: angular.IComponentOptions = {
    controller: DocumentRegistrationEditController,
    template: require('./documentRegistrationEdit.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-registration/documentRegistrationEdit.ts